import { Component, Input, HostListener, Output, EventEmitter, ViewChild, OnInit } from '@angular/core';
import { MemberLevelModel } from '../models/member-level-model';

import { Router } from '@angular/router';
import { Modal } from 'ngx-modal';

@Component({
    selector: "member-level",
    templateUrl: "../templates/template1/views/member-level-popup.component.html",
    styleUrls: ["../templates/template1/themes/default/css/profile-info.less"],
    providers: []
})
export class MemberLevelPopupComponent implements OnInit {
    @Input() review: MemberLevelModel;
    @ViewChild('memberLevel') memberLevelPopup: Modal;
    constructor(private route: Router) {
    }
    ngOnInit() {
        if (this.review && this.review.toggle) {
            this.memberLevelPopup.open();
        }
    }

    closePopup() {
        this.review.toggle = false;
        this.memberLevelPopup.close();
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event.keyCode === 27) {
            this.closePopup();
        }
    }
} 
 



// WEBPACK FOOTER //
// ./src/app/customerservice/components/member-level-popup.component.ts